import { createI18n } from "vue-i18n";
import de from "./assets/locales/de.json";

function getStartingLocale() {
  if (localStorage.getItem("last-locale")) {
    return localStorage.getItem("last-locale");
  }
  return "de";
}

const i18n = createI18n({
  locale: getStartingLocale(),
  messages: {
    de
  },
});

const $t = i18n.global.t;

export { i18n, $t };
